import { Breadcrumb } from '@ui/Breadcrumb/Breadcrumb';
import { useBreadcrumbContext } from '@shared/contexts';

export const Header = () => {
  const { alertTitle } = useBreadcrumbContext();

  return (
    <div className="w-full relative">
      <Breadcrumb alertTitle={alertTitle || undefined} />
    </div>
  );
}; 